import { Text } from 'ui-kit/typography'
import {
  selfHostingBenefitsData,
  SelfHostingBenefitsDataType,
} from './selfHostingBenefitsData'
import classes from './SelfHostingBenefits.module.scss'

export const SelfHostingBenefits = () => {
  return (
    <ul className={classes.list}>
      {selfHostingBenefitsData.map((item, index) => (
        <SelfHostingBenefitsCard key={index} item={item} />
      ))}
    </ul>
  )
}

const SelfHostingBenefitsCard = ({
  item,
}: {
  item: SelfHostingBenefitsDataType
}) => {
  const { Icon, description } = item

  return (
    <li className={classes.item}>
      <Icon className={classes.icon} />
      <Text balance className={classes.description}>
        {description}
      </Text>
    </li>
  )
}
